import { z } from "zod";

import { accountSchema } from "./account";

const gemLeaderSchema = z
  .object({
    rank: z.string(),
    gem_amount: z.number(),
    account: accountSchema,
  })
  .transform((data) => ({
    ...data,
    id: `${data.account.id}-rank-${data.rank}`,
  }));

type GemLeader = z.infer<typeof gemLeaderSchema>;

export { gemLeaderSchema, type GemLeader };
